import { ChangeEvent, useState } from 'react';
import {
  AccountCircle,
  NightsStay,
  ExitToApp,
  WbSunny,
  Lock,
} from '@material-ui/icons';
import { ChangePassword } from '../ChangePassword';
import { Menu, MenuItem } from '../Menu';
import { Switch } from '../Switch';
import { ListItemText } from '../ListItemText';

interface Props {
  anchorEl: HTMLElement | null;
  isDarkMode: boolean;
  onClose(): void;
  setDarkMode(value: boolean): void;
  user: UserContext;
}

export const UserMenu = ({
  anchorEl,
  onClose,
  user,
  isDarkMode,
  setDarkMode,
}: Props) => {
  const [changePasswordOpen, setChangePasswordOpen] = useState(false);

  const handleLogout = () => {
    user.logout();
    onClose();
  };

  const handleSwitchChange = (event: ChangeEvent<HTMLInputElement>) => {
    event.target.checked ? setDarkMode(true) : setDarkMode(false);
  };

  return (
    <>
      <Menu
        id="userMenu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={onClose}
        placement="auto"
      >
        <MenuItem className="!py-4">
          <AccountCircle color="inherit" fontSize="large" />
          <ListItemText
            primary={(user.email ?? '').split('@')[0].toUpperCase()}
            secondary={user.email}
          />
        </MenuItem>
        <MenuItem className="border-y border-border-dark">
          <Switch
            checked={isDarkMode}
            checkedIcon={<NightsStay fontSize="inherit" />}
            icon={<WbSunny fontSize="inherit" />}
            onChange={handleSwitchChange}
          />
          {`Dark Mode (${isDarkMode ? 'On' : 'Off'})`}
        </MenuItem>
        <MenuItem
          onClick={() => {
            setChangePasswordOpen(true);
            onClose();
          }}
        >
          <Lock color="inherit" />
          Change Password
        </MenuItem>
        <MenuItem onClick={handleLogout}>
          <ExitToApp color="inherit" />
          Logout
        </MenuItem>
      </Menu>
      <ChangePassword
        open={changePasswordOpen}
        onClose={() => setChangePasswordOpen(false)}
      />
    </>
  );
};
